import { Navigate, useLocation, useParams } from 'react-router-dom';
import { Loader } from '@quero-delivery/quero-components-web';
import { Helmet } from 'react-helmet';

import FranchiseForm from '@/features/franchise-form/FranchiseForm';
import { GOOGLE_MAPS_EMBED_API_KEY } from '@/_config/env';

import { useGetCityFareById } from '@/api/fares/get-city-fare-by-id';
import { useCityFareFormAccess } from '@/features/fare/hooks/use-city-fare-form-access';
import { useLinkedMunicipioIds } from '@/features/fare/hooks/use-linked-municipio-ids';

function FranchiseFormContainer() {
  const { franchiseId } = useParams<{ franchiseId?: string }>();
  const location = useLocation();
  const { isLogisticOperator } = useCityFareFormAccess();
  const { isMunicipioAllowed, isCheckingLinkedMunicipios } =
    useLinkedMunicipioIds();

  const isToCreate = location.pathname.includes('criar');

  const isToCreateAndOL = isToCreate && isLogisticOperator;
  const isEditRoute = !!franchiseId && !isToCreate;
  const isMunicipioDenied =
    isEditRoute &&
    !isCheckingLinkedMunicipios &&
    !isMunicipioAllowed(franchiseId);

  const {
    data: cityFareData,
    isFetching: isLoadingCityFare,
    error: cityFareError,
  } = useGetCityFareById(franchiseId || '', {
    enabled:
      !!franchiseId &&
      !isToCreateAndOL &&
      !isCheckingLinkedMunicipios &&
      isMunicipioAllowed(franchiseId),
  });

  if (isToCreateAndOL || isMunicipioDenied || (isEditRoute && cityFareError)) {
    return <Navigate to="/tarifas" replace />;
  }

  return (
    <div className="container">
      <Helmet>
        {!window.google?.maps ? (
          <script
            src={`https://maps.googleapis.com/maps/api/js?libraries=places&key=${GOOGLE_MAPS_EMBED_API_KEY}&language=pt-BR`}
          />
        ) : null}
      </Helmet>

      {isCheckingLinkedMunicipios ||
      isLoadingCityFare ||
      (franchiseId && !cityFareData) ? (
        <Loader size="md" />
      ) : (
        <FranchiseForm
          franchise={isToCreate ? undefined : cityFareData || undefined}
        />
      )}
    </div>
  );
}

export default FranchiseFormContainer;
